import { useAnalytics } from '@/hooks/analytics';
import { useUserState } from '@/hooks/store';
import { useRouterPush } from '@/hooks/utils/useRouterPush';

import CalmFeatures from '../CalmFeatures';
import Exclusive from '../Exclusive';
import Hero from '../Hero';
import { JayLandingPageLayoutProps, OnJayCtaClick } from './types';

export const jayCustomSeo = {
	primaryDescription:
		'Join former monk, purpose coach and best-selling author Jay Shetty on a journey to find calm and take positive action toward the life of your dreams.',
	description:
		'Join former monk, purpose coach and best-selling author Jay Shetty on a journey to find calm and take positive action toward the life of your dreams.',
	imageUrl: '/_n/images/jayshetty/jay-meta.png',
};

const JayLandingPageLayout = ({ isTrialFlow }: JayLandingPageLayoutProps) => {
	const { logEvent } = useAnalytics();
	const routerPush = useRouterPush();
	const user = useUserState();

	const onCtaClick: OnJayCtaClick = async ({ section, copy, pos }) => {
		logEvent({
			eventName: 'Page : CTA : Clicked',
			eventProps: {
				page_name: isTrialFlow ? 'daily_jay' : 'jay',
				section,
				pos,
				copy,
				type: 'button',
			},
		});

		if (user?.subscription?.valid) {
			await routerPush(isTrialFlow ? '/dailyjay/download' : '/jay/download');
		} else {
			await routerPush(isTrialFlow ? '/dailyjay/signup' : '/jay/signup');
		}
	};

	return (
		<>
			<Hero onCtaClick={onCtaClick} isTrialFlow={isTrialFlow} />
			<Exclusive onCtaClick={onCtaClick} />
			<CalmFeatures />
		</>
	);
};

export default JayLandingPageLayout;
